import { RouterV2Enum } from '@/router/router-names';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

import style from './index.module.scss';
import BottomTips from '../bottomTips';
import MarketPage from './market/marketPage';
import { PageVersionTypeEnums } from '../../types';

/** TODO:后续重构优化，直接根据当前版本类型渲染命名，不另外做样式计算 */
enum pageStyle {
  DEFAULT = 'default',
  MARKET = 'marketPage',
  NEW = 'NewPage',
  NOT_IMMEDIATE_CALL = 'NotImmediateWithAb'
}

@Component({ name: 'NewPage' })
export default class NewPage extends Vue {
  @Prop(String) readonly isImmediateCall!: boolean;

  // 页面版本
  @Prop(String) readonly pageVersion!: PageVersionTypeEnums

  private pageType: pageStyle = pageStyle.DEFAULT;

  /** 调用ab测，用来区分命中哪种营销落地页 */
  @Watch('isImmediateCall', { immediate: true })
  private onchange() {
    // 前置判断market-page（臻有钱元素营销页），这个版本不走ab
    if (this.$route.path.includes(RouterV2Enum.marketPage)) {
      this.pageType = pageStyle.MARKET;
      return;
    }

    if (!this.isImmediateCall) {
      this.pageType = pageStyle.NOT_IMMEDIATE_CALL;
    } else {
      this.pageType = pageStyle.NEW;
    }
  }

  private redirectApp() {
    this.$emit('redirectApp');
  }

  private render() {
    if ([pageStyle.MARKET].indexOf(this.pageType) >= 0) {
      return (
        <MarketPage
          pageVersion={this.pageVersion}
          onRedirectApp={this.redirectApp.bind(this)}
        />
      );
    }
    return (
      <div class={style[this.pageType]}>
          <div class={style['main-wrapper']}>
              <div class={[style['main-title'], style['main-color']]}>急速借款 · 最高可借</div>
              <div class={style['possible-num']}>200,000</div>
              <div class={style['product-description']}>
                <span class={style['description-gery']}>综合年化利率（单利）4.9%-24%</span>
              </div>
              <div class={style['apply-btn']}
                onClick={this.redirectApp.bind(this)}>
                立即领取
              </div>
            </div>
            <BottomTips pageVersion={this.pageVersion} />
      </div>
    );
  }
}
